<template>
  <div>
    <div class="details-container">
      <v-tabs class="tabs">
        <div class="tab-btns">
          <v-tab id="tab-recording">
            <v-icon>tv</v-icon>
            &nbsp;Recording
          </v-tab>
          <v-tab id="tab-info">
            <v-icon>info_outline</v-icon>
            &nbsp;Info
          </v-tab>
          <v-tab id="tab-issues-list">
            <v-icon>list</v-icon>
            &nbsp;Issues List
          </v-tab>
        </div>
        <v-tab-item key="0">
          <Recording />
        </v-tab-item>
        <v-tab-item key="1">
          <RecordingInfo />
        </v-tab-item>
        <v-tab-item key="2">
          <IssuesList />
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import Recording from './Recording';
import RecordingInfo from './RecordingInfo';
import IssuesList from './IssuesList';

export default {
  name: 'ViewDetails',
  components: {
    Recording,
    RecordingInfo,
    IssuesList,
  },
  data() {
    return {
      active: null,
    };
  },
  computed: {
    ...mapState({
      issues: state => _.sortBy(state.issues.data, 'created').reverse(),
    }),
  },
};
</script>

<style lang="scss">
@media (min-width: 450px) {
  .details-container {
    .tabs__container {
      height: 58px;
    }
    .tabs__bar {
      border-bottom: 1px solid gainsboro;
    }
    .tab-btns {
      .tabs__div {
        .tabs__item {
          padding: 20px;
        }
      }
      margin-left: 100px;
    }
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ViewDetails.vue